import useViewports from '../../../../../../Hooks/useViewports';
import { Image } from 'react-bootstrap';
import Styles from './ZoomImage.module.scss?module';
import ZoomImageContainer from './ZoomImageContainer/ZoomImageContainer';
import Overlay from '../Overlay/Overlay';

const ZoomImage = ({ src, alt = 'product image', product }) => {
  const { xs, sm, md } = useViewports();

  const zoomProps = {
    width: 225,
    height: 225,
    img: src,
    scale: 2.6,
    zoomPosition: 'right',
    alt: alt,
    className: Styles.ZoomContainer,
  };

  return (
    <div className={Styles.ImageContainer}>
      {xs || sm || md ? (
        <Image fluid src={src} className="h-auto" alt={alt} />
      ) : (
        <ZoomImageContainer zoomProps={zoomProps} />
      )}

      {product && (product.is_new || product.image_overlay_uri) && (
        <div className={Styles.OverlayWrapper}>
          <Overlay {...product} />
        </div>
      )}
    </div>
  );
};

export default ZoomImage;
